module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Chairs.b30c4d7d.jpg";